// extracted by mini-css-extract-plugin
export default {"searchPopover":"SearchResourcesPopover_searchPopover__CFtOl"};